import React, { Suspense, useLayoutEffect } from "react";
import { BrowserRouter as Router, Route, withRouter } from "react-router-dom";
import GlobalSeo from "./components/seo/GlobalSeo";

// Preloader
const Preloader = React.lazy(() => import("./components/layouts/Preloader"));

// Pages
const HayamHome = React.lazy(() => import("./components/pages/Hayam-Home"));
const Roomgrid = React.lazy(() => import("./components/pages/Roomgrid"));
const Roomlist = React.lazy(() => import("./components/pages/Roomlist"));
const Roomdetails = React.lazy(() => import("./components/pages/Roomdetails"));
const Blog = React.lazy(() => import("./components/pages/Blog"));
const Blogstandard = React.lazy(() =>
  import("./components/pages/Blogstandard")
);
const Blogdetails = React.lazy(() => import("./components/pages/Blogdetails"));
const Contact = React.lazy(() => import("./components/pages/Contact"));
const About = React.lazy(() => import("./components/pages/About"));
const Gallery = React.lazy(() => import("./components/pages/Gallery"));
const Services = React.lazy(() => import("./components/pages/Services"));
const Events = React.lazy(() => import("./components/pages/Events"));
const Placesdetails = React.lazy(() =>
  import("./components/pages/Placesdetails")
);
const Booking = React.lazy(() => import("./components/pages/Booking"));
const Termsandconditions = React.lazy(() =>
  import("./components/pages/Termsandconditions")
);

// Scroll to Top
const ScrollToTop = withRouter(({ children, location: { pathname } }) => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
});

function App() {
  return (
    <Router>
      <Suspense fallback={<div></div>}>
        <ScrollToTop>
          <GlobalSeo />
          <Preloader />
          <Route path="/" exact component={HayamHome} />
          <Route path="/room-grid" exact component={Roomgrid} />
          <Route path="/room-list" exact component={Roomlist} />
          <Route path="/room-details/:id" exact component={Roomdetails} />
          <Route path="/blog" exact component={Blog} />
          <Route
            path="/blog/cat/:catId"
            exact
            component={(props) => (
              <Blog {...props} key={window.location.pathname} />
            )}
          />
          <Route
            path="/blog/tag/:tagId"
            exact
            component={(props) => (
              <Blog {...props} key={window.location.pathname} />
            )}
          />
          <Route
            path="/blog/user/:userId"
            exact
            component={(props) => (
              <Blog {...props} key={window.location.pathname} />
            )}
          />
          <Route path="/blog-standard" exact component={Blogstandard} />
          <Route path="/blog-details/:id" exact component={Blogdetails} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/about" exact component={About} />
          <Route path="/gallery" exact component={Gallery} />
          <Route path="/services" exact component={Services} />
          <Route path="/events" exact component={Events} />
          <Route path="/places-details/:id" exact component={Placesdetails} />
          {/* <Route path="/booking/:startDate/:endDate/:numberOfGuests/" exact component={Booking} /> */}
          <Route path="/booking/" exact component={Booking} />
          <Route
            path="/termsandconditions"
            exact
            component={Termsandconditions}
          />
          <a
            href={`https://wa.me/5215532231857?text=${encodeURIComponent(
              "Hi, I’m interested in Casa Hayam"
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              position: "fixed",
              left: "16px",
              bottom: "16px",
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              backgroundColor: "#25D366",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
              zIndex: 1000,
            }}
          >
            <i className="fab fa-whatsapp" style={{ fontSize: "28px" }} />
          </a>
          <Route path="/*" exact component={() => <div>no encontrado</div>} />
        </ScrollToTop>
      </Suspense>
    </Router>
  );
}

export default App;
